import React from 'react';

// File imported
import PageContainer from "../../container/CustomPage";


import HomeBlogPageHeader from "../../components/PageHeader/HomeBlog";
import AccountSettingsContainer from "../../container/account";
import Blog from "../../components/blog";
import LoadMore from "../../components/loadmore";
import Loading from "../../components/loading";


import blogData from '../../data/blog'

const ContentAccountSettingsPage = () => {
    return (
        <PageContainer classes={'bg-grey'}>
            <div className="section-wrap section">
                <AccountSettingsContainer/>
            </div>
        </PageContainer>
    );
};

export default ContentAccountSettingsPage;
